
export default {
  // Profile
  "profile_reviews": "评论",
  "profile_no_reviews": "暂无评论",
  "profile_share_experience": "与胶片社区分享您的体验！",
  "verified_traveler": "已验证的旅行者",
  "verified_creative": "已验证的创作者",
  "verified_traveler_tooltip": "此用户是已验证的旅行者",
  "verified_creative_tooltip": "已验证的摄影师或创意专业人士",
  "favorite_airports": "收藏的机场",
  "no_favorite_airports": "暂无收藏的机场",
  "user_favorites": "用户收藏",
  "manage_favorites": "管理收藏"
};
